// third-party
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
// import { getFirestore, collection, getDocs } from 'firebase/firestore/lite'
import { appConfigProd, firebaseConfigDevApp } from "../../config";

import { isDev } from "../../util";

// firebase initialize
if (!firebase.apps.length) {
  firebase.initializeApp(isDev() ? firebaseConfigDevApp.firebase : appConfigProd.firebase);
}
// Initialize Firebase
// const db = getFirestore(firebaseApp);
const db = firebase.firestore();

export const createColleciton = async(
  collectionName: string,
  docName: string,
  data: any
) => {
  // const collectionValue = collection(db, collectionName);
  // const documentValue = await getDocs(collectionValue);
  // const cityList = documentValue.docs.map(doc => doc.data());
  // return cityList;

  return new Promise((resolve, reject) => {
    db.collection(collectionName)
      .doc(docName)
      .set(data)
      .then(() => {
        console.log("FIRESTORE collection created!", { docName, data });
        resolve(true);
      })
      .catch((e) => {
        console.error("FIRESTORE collection created error", e);
        reject(e);
      });
  });
};

const stripForFirestore = (value: any): any => {
  if (Array.isArray(value)) {
    return value.map(stripForFirestore);
  }
  if (value && typeof value === "object") {
    if (typeof value.toDate === "function") {
      return value.toDate().toISOString();
    }
    const cleaned: any = {};
    Object.keys(value).forEach((key) => {
      if (value[key] !== undefined) {
        cleaned[key] = stripForFirestore(value[key]);
      }
    });
    return cleaned;
  }
  return value;
};

export const updateCollection = (
  collectionName: string,
  docName: string,
  data: any
) => {
  const payload = stripForFirestore(data);
  return new Promise((resolve, reject) => {
    db.collection(collectionName)
      .doc(docName)
      .update(payload)
      .then(() => {
        console.log("FIRESTORE updateCollection updated!", payload);
        resolve(payload)
      })
      .catch((e) => {
        console.error("FIRESTORE updateCollection created error", e);
        reject(e);
      });
  });
};

export const getColleciton = async (collectionName: string) => {
  try {
    const snapshot = await db.collection(collectionName).get();
    const collectionData: any = [];
    snapshot.forEach((doc) =>
      collectionData.push({ ...doc.data(), id: doc.id })
    );
    return collectionData;
  } catch (e) {
    console.log("FIRESTORE getColleciton error", { e, collectionName });
    return null;
  }
};
export const getCollecitonByDocName = async (
  collectionName: string,
  docName: string
) => {
  try {
    return await db
      .collection(collectionName)
      .doc(docName)
      .get();
  } catch (e) {
    console.log("FIRESTORE getCollecitonByDocName error", e);
    return null;
  }
};
export const handleUploadImage = (image: any, folderName = "adhaar") =>
  new Promise((resolve, reject) => {
    let file = image;
    const storage = firebase.storage();
    const storageRef = storage.ref();
    const uploadTask = storageRef.child(`${folderName}/` + file.name).put(file);

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      (_snapshot) => {
        storageRef
          .child(file.name)
          .getDownloadURL()
          .then((url) => {
            console.log(url);
          });
      },
      (error) => {
        reject(error);
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((url) => {
          //   console.log('image download url:', url);
          resolve(url); // this is important
        });
      }
    );
  });
